import * as React from 'react';
import { MeatballMenu } from 'ui';
import { SearchFiltersTranslation } from '../constants';
import { FilterMenuOption, FilterMenuValues } from './types';

import styles from './filter-meatball-menu.scss';

interface FilterMeatballMenuProps {
  id: string;
  options: FilterMenuOption;
  values?: FilterMenuValues;
  onClear: () => void;
  onChange?: (id: string, values: FilterMenuValues) => void;
  translation: SearchFiltersTranslation;
  meatballClassName?: string;
}

export class FilterMeatballMenu extends React.PureComponent<FilterMeatballMenuProps> {

  private onIncludeExclude = () => {

    const { id, values, onChange } = this.props;

    onChange?.(id, {
      ...values,
      exclude: !values?.exclude
    });
  };

  private onIncludeExcludeChildren = () => {

    const { id, values, onChange } = this.props;

    onChange?.(id, {
      ...values,
      excludeChildren: !values?.excludeChildren
    });
  };

  private onIncludeExcludeParents = () => {

    const { id, values, onChange } = this.props;

    onChange?.(id, {
      ...values,
      excludeParents: !values?.excludeParents
    });
  };

  public render() {

    const { options, values, onClear, translation, meatballClassName } = this.props;

    if (!options) {
      return null;
    }

    return <div className="clearfix">
      <div className="float-end">
        <div className={styles.filterMeatballMenu}>
          <MeatballMenu closeAfterClick className={meatballClassName}>
            {options.clear && <li>
              <button type="button" className="dropdown-item" onClick={onClear}>
                {translation.clear_filter}
              </button>
            </li>}
            {options.excludeInclude && values?.exclude && <li>
              <button type="button" className="dropdown-item" onClick={this.onIncludeExclude}>
                {translation.filter_menu_option_include}
              </button>
            </li>}
            {options.excludeInclude && !values?.exclude && <li>
              <button type="button" className="dropdown-item" onClick={this.onIncludeExclude}>
                {translation.filter_menu_option_exclude}
              </button>
            </li>}
            {options.excludeIncludeChildren && values?.excludeChildren && <li>
              <button type="button" className="dropdown-item" onClick={this.onIncludeExcludeChildren}>
                {translation.filter_menu_option_include_sub}
              </button>
            </li>}
            {options.excludeIncludeChildren && !values?.excludeChildren && <li>
              <button type="button" className="dropdown-item" onClick={this.onIncludeExcludeChildren}>
                {translation.filter_menu_option_exclude_sub}
              </button>
            </li>}
            {options.excludeIncludeParents && values?.excludeParents && <li>
              <button type="button" className="dropdown-item" onClick={this.onIncludeExcludeParents}>
                {translation.filter_menu_option_include_parent}
              </button>
            </li>}
            {options.excludeIncludeParents && !values?.excludeParents && <li>
              <button type="button" className="dropdown-item" onClick={this.onIncludeExcludeParents}>
                {translation.filter_menu_option_exclude_parent}
              </button>
            </li>}
          </MeatballMenu>
        </div>
      </div>
    </div>;
  }
}
